<template>
<div>
    <div class="holiday-breaks-input">
		<div name="holiday-breaks-input--calendar">
            <div v-show="true" :title="current_id != null ? 'Edit break' : 'Add break'">
                <FlatpickrCalendar
                ref="fp_calendar"
                :create_url="create_url"
                :update_url="update_url"
                :destroy_url="destroy_url"
                :copy_jobs="copy_jobs"
                :refresh_on_new_data="false"
                :button="false"
                v-on:add-break="addBreak"
                v-on:update-break="updateBreak"
                v-on:remove-break="removeBreak"
                >
                </FlatpickrCalendar>
            </div>
        </div>
    </div>
    <div class="">
        <Calendar
            style="custom"
            :key="calendar_key"
            :year="current_cal_year"
            :data-source="data_source"
            :enable-range-selection="true"
            :enable-context-menu="false"
            :allow-overlap="false"
            @click-day="clickDay"
            @select-range="selectRange"
            @year-changed="matchDatesToSelectedYear">
        ></Calendar>
    </div>
</div>
</template>

<script>
	import flatpickr from "flatpickr";
	import Loader from "../general_components/Loader";
    import Calendar from 'v-year-calendar';
    import FlatpickrCalendar from '../settings/FlatpickrCalendar.vue';

    var current_year = new Date().getFullYear();

	export default {
		name: "HolidayBreaks",
		components: {Loader, Calendar, FlatpickrCalendar, flatpickr},
		props: {
			value: {
				type: Array,
				required: true
			},

			create_url: {
				type: String,
				required: true
			},
			update_url: {
				type: String,
				required: true
			},
			destroy_url: {
				type: String,
				required: true
			},

			copy_jobs: {
				type: Boolean,
				default: false
			},
		},
		data(){
			return {
				holidays_edit: [],

				entry_id: null,
				entry_repeats: false,
				entry_existing_jobs: false,

				editing: false,
				saving: false,

                current_id: null,
                start_date: null,
                end_date: null,

                data_source: [],
                current_cal_year: current_year,
                calendar_key: 0,
			}
		},

		beforeMount() {
			this.holidays_edit = Object.assign([], this.value);
		},

		mounted() {
			document.addEventListener('click', this.clicked);
		},

		methods: {

            selectRange: function(e) {
                this.entry_id = null;
                this.entry_repeats = false;
                this.start_date = e.startDate;
                this.end_date = e.endDate;

                this.updateFlatpickrDates();
            },

            clickDay: function(e) {
                if(e.events.length > 0){
                    let event = e.events[0];

                    this.entry_id = event.id;
                    this.start_date = new Date(event.startDate);
                    this.end_date = new Date(event.endDate);
                    this.entry_repeats = event.repeats;

                    this.updateFlatpickrDates();
                }
            },


			clicked(event, forced = false){
                // don't close the modal if the form is saving
				if (this.saving) return;

                // check the modal is being forced to be hidden by another method
				if (forced){
                    this.editing = false;
					return;
				}
			},

            // Set the year values for events
            // If the event is set to repeat, update it's year value as the calendar year changes
            matchDatesToSelectedYear: function(yearChanged = {'currentYear': this.current_cal_year}){
                // empty the data_source array to ensure the calendar updates
                this.data_source.splice(0, this.data_source.length);
                this.holidays_edit.forEach((e) => {
                    let year = this.current_cal_year;
                    let event_start_date = e.start_date ?? e.startDate;
                    let event_end_date = e.end_date ?? e.endDate;

                    // get the year the event first happened
                    let event_start_year = new Date(event_start_date).getFullYear();

                    // check the event repeats and the current year isn't before the first year the event happened
                    if(e.repeats && yearChanged.currentYear >= event_start_year){
                        year = yearChanged.currentYear;
                    }

                    // Flatpickr and v-year use different name for date variables so check which has data
                    let start_date = this.convertStringDateToDateMSObject(event_start_date, year);
                    let end_date = this.convertStringDateToDateMSObject(event_end_date, year);

                    this.addBreakToDataSource(e.id, start_date, end_date, e.repeats);
                });
            },

            // Convert the date strings into milliseconds for v-year-calendar
            convertStringDateToDateMSObject(string_date, year = this.current_cal_year){
                let string_date_split = string_date.split('-');
                string_date_split[2] = string_date_split[2].slice(0,2);

                let date_string = `${year}-${string_date_split[1]}-${string_date_split[2]}`
                return Date.parse(date_string);
            },

            // Add the breaks to the v-year-calendar with the blue accent
            addBreakToDataSource(id, start, end, repeats = false){
                let color = '#1db2f8';

                // Generate a random hex code for the color (May be useful later)
                // color = '#' + Math.floor(Math.random()*16777215).toString(16);
                this.data_source.push({
                    color: color,
                    id: id,
                    name: 'Break',
                    startDate: start,
                    endDate: end,
                    repeats: repeats
                })
            },

            updateFlatpickrDates(startDate = this.start_date, endDate = this.end_date){
                // Update the global active date range
                this.start_date = startDate;
                this.end_date = endDate;

                // Show the modal
                this.editing = true;

                if(this.entry_id!=null){
                    this.$refs.fp_calendar.setEventInfo(this.entry_id, this.entry_repeats, this.entry_existing_jobs);
                }else{
                    this.$refs.fp_calendar.resetValues();
                }
                this.$refs.fp_calendar.setFlatpickrDates(this.start_date, this.end_date);
            },

            addBreak(event){

                this.holidays_edit.push(event);
                this.$emit('input', this.holidays_edit);

                this.matchDatesToSelectedYear();
            },

            updateBreak(event){
                let idx = this.holidays_edit.findIndex((e => e.id == event.id));
                this.holidays_edit[idx] = event;

                this.$emit('input', this.holidays_edit);

                this.matchDatesToSelectedYear();
                this.forceRerender()
            },

            removeBreak(eventid){
                this.holidays_edit = this.holidays_edit.filter(item => item.id != eventid);

                this.data_source = this.data_source.filter(item => item.id != eventid);
            },

            // Force the v-year-calendar to redraw itself with new data after api request
            forceRerender() {
                this.calendar_key += 1;
            }
		},

		watch: {
			value(){
				this.holidays_edit = Object.assign([], this.value);
			}
		},

	}
</script>

